import axios from '@/util/axios'
import { NEW_API_CONFIG, DEV_API_TOKEN } from '@/util/constants'
import store from '@/store'
import { handleApiError as handleError } from '@/util/axios_common'

/**
 * 支払い方法取得
 */
export const fetchPaymentMethod = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/SN/001', r).catch(handleError)
}

/**
 * 請求書一覧取得
 */
export const listInvoices = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/SN/002', r).catch(handleError)
}

/**
 * 請求書・代金明細出力
 */
export const outputInvoices = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/SN/003', r).catch(handleError)
}

/**
 * 顧客情報同期
 */
export const synchronizeCustomerInfo = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/AD/SN/004', r).catch(handleError)
}

/**
 * 自動決済有効
 */
export const enableAutomaticPayment = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/AD/SN/005', r).catch(handleError)
}

/**
 * 自動決済解約API		
 */
export const cancelAutomaticPayment = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/AD/SN/006', r).catch(handleError)
}

/**
 * 商品同期
 */
export const synchronizeProducts = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/AD/SN/007', r).catch(handleError)
}

/**
 * WEB会員認証API
 */
export const authenticateWebMember = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/SN/008', r).catch(handleError)
}

/**
 * 支払い方法指定
 */
export const setPaymentMethod = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/SN/009', r).catch(handleError)
}

/**
 * 申請情報取得
 */
export const fetchApplicationInfo = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/SN/010', r).catch(handleError)
}
